export default __webpack_public_path__ + "static/media/icon_completed.5f12ae74.svg";